import { IssueTime } from '../commonbasiccomponents/IssueTime';
import { NoticePurpose } from '../eforms_ubl_extension_aggregate_components/NoticePurpose';
import { Language } from '../commonaggregatecomponents/Language';
import { BriefDescription } from '../commonbasiccomponents/BriefDescription';
import { VersionID } from '../commonbasiccomponents/VersionID';
import { Signature } from '../commonaggregatecomponents/Signature';
import { Capability } from '../commonaggregatecomponents/Capability';
import { UBLVersionID } from '../commonbasiccomponents/UBLVersionID';
import { NoticeSubType } from '../eforms_ubl_extension_aggregate_components/NoticeSubType';
import { UBLExtensions } from '../commonextensioncomponents/UBLExtensions';
import { IssueDate } from '../commonbasiccomponents/IssueDate';
import { ProfileExecutionID } from '../commonbasiccomponents/ProfileExecutionID';
import { NoticeTypeCode } from '../commonbasiccomponents/NoticeTypeCode';
import { Party } from '../commonaggregatecomponents/Party';
import { NoticeLanguageCode } from '../commonbasiccomponents/NoticeLanguageCode';
import { Note } from '../commonbasiccomponents/Note';
import { CustomizationID } from '../commonbasiccomponents/CustomizationID';
import { ProfileID } from '../commonbasiccomponents/ProfileID';
import { ID } from '../commonbasiccomponents/ID';
import { RegulatoryDomain } from '../commonbasiccomponents/RegulatoryDomain';
import { UUID } from '../commonbasiccomponents/UUID';
import { BusinessPartyGroup } from '../eforms_ubl_extension_aggregate_components/BusinessPartyGroup';
import { DocumentReference } from '../commonaggregatecomponents/DocumentReference';
import { RequestedPublicationDate } from '../commonbasiccomponents/RequestedPublicationDate';
import { PreviousVersionID } from '../commonbasiccomponents/PreviousVersionID';

export class BusinessRegistrationInformationNotice  {

	note: Array<Note>;
	businessPartyGroup: Array<BusinessPartyGroup>;
	issueTime: IssueTime;
	requestedPublicationDate: RequestedPublicationDate;
	signature: Array<Signature>;
	uuid: UUID;
	profileExecutionID: ProfileExecutionID;
	noticePurpose: Array<NoticePurpose>;
	previousVersionID: PreviousVersionID;
	versionID: VersionID;
	brochureDocumentReference: Array<DocumentReference>;
	profileID: ProfileID;
	noticeSubType: NoticeSubType;
	id: ID;
	issueDate: IssueDate;
	businessCapability: Array<Capability>;
	regulatoryDomain: Array<RegulatoryDomain>;
	receiverParty: Party;
	customizationID: CustomizationID;
	ublExtensions: UBLExtensions;
	noticeLanguageCode: NoticeLanguageCode;
	additionalNoticeLanguage: Array<Language>;
	noticeTypeCode: NoticeTypeCode;
	businessParty: Party;
	senderParty: Party;
	ublVersionID: UBLVersionID;
	briefDescription: Array<BriefDescription>;
	additionalDocumentReference: Array<DocumentReference>;
}
